import { useState, useEffect } from 'react';
import { getMoistureForecast } from '../utils/api';

// useMoistureForecast reports whether a device's soil is trending towards too dry
// within the next few days, fitted server-side from the drying trend since it was
// last watered.
//
// This is a warning, not an alert: it never appears in the weekly email and never
// makes a device unhealthy. A failure resolves to no warning rather than an error
// state — the badge is supplementary, and a broken forecast must not take the
// moisture chart down with it.
export const useMoistureForecast = (deviceId) => {
	const [forecast, setForecast] = useState(null);

	useEffect(() => {
		if (!deviceId) {
			return;
		}

		let cancelled = false;
		const fetchForecast = async () => {
			// Reset per device, otherwise switching devices briefly shows the
			// previous plant's warning against the new one's chart.
			setForecast(null);
			try {
				const response = await getMoistureForecast(deviceId);
				if (!response.ok) {
					return;
				}
				const json = await response.json();
				if (!cancelled) {
					setForecast(json.data);
				}
			} catch (err) {
				console.error(err);
			}
		};

		fetchForecast();
		return () => {
			cancelled = true;
		};
	}, [deviceId]);

	return { forecast };
};

export default useMoistureForecast;
